<template>
  <div class="full_page">
    <h1>HARD 8TH</h1>
    <div class="row">
      <div class="col-12">
        <table class="table table-striped table-bordered table-hover table-condensed">
          <thead>
          <tr>
            <th>Customer Name</th>
            <th>Qty Total</th>
            <th>Avg Qty Day</th>
            <th>Times Ordered</th>
            <th>First Hard 8th Date</th>
            <th>Last Hard 8th Date</th>
            <th>Hard 8th Last Order Days</th>

<!--            <th>Avg Sales Month</th>-->

            <th>Last Order Date</th>
            <th>Run Out In Days</th>
            <th>LFB # of Orders</th>
            <th>LFB Rewards</th>
            <th>LFB Last Order</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="customer in order_list_by_product_sku_hard8th" v-bind:key="customer.customer_id" :style="{color: line_color(customer.list_color), background: background_color(customer.has_to_pay)}">
            <td style="cursor: pointer; text-decoration: underline" v-on:click="show_customer_detail_page(customer.customer_id)">{{customer.customer_display_name}}</td>

            <td>{{customer.total_qty_ordered_product_sku}}</td>
            <td>{{customer.total_qty_ordered_average_per_day_product_sku}}</td>
            <td>{{customer.number_of_orders_product_sku}}</td>
            <td>{{customer.first_placed_order_date_product_sku}}</td>

            <template v-if="customer.product_sku_last_date_different === 1">
              <td class="mark_different">{{customer.last_placed_order_date_product_sku}}</td>
            </template>
            <template v-else>
              <td>{{customer.last_placed_order_date_product_sku}}</td>
            </template>

            <td>{{customer.days_since_last_order_product_sku}}</td>

<!--            <td>{{customer.avg_sales_month}}</td>-->

            <td>{{customer.last_placed_order_date}}</td>
            <td>{{customer.runs_out_in_days}}</td>

            <template v-if="customer.lfb_has_account === 1">
              <td>{{customer.lfb_order_count}}</td>
              <td>{{customer.lfb_reward_point}}</td>
              <td>{{customer.lfb_last_order_date}}</td>
            </template>
            <template v-else>
              <td></td>
              <td></td>
              <td></td>
            </template>

          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      order_list_by_product_sku_hard8th: 'admin/order_list_by_product_sku_hard8th',
    }),
  },
  mounted() {
    this.get_order_list();
  },
  methods: {
    line_color: function(list_color) {
      if(list_color === 3) {
        return '#00C000';
      }
      if(list_color === 5) {
        return '#007000';
      }

      if(list_color === 4) {
        return '#FF0000';
      }
      if(list_color === 6) {
        return '#C00000';
      }

      return '#000000';
    },
    background_color: function(background_color) {
      if(background_color === 1) {
        return '#FFFF00';
      }
      return null;
    },
    get_order_list () {
      if(this.order_list_by_product_sku_hard8th.length === 0)
      {
        this.$store.dispatch('admin/getOrdersListByProductSKU',{'product_sku': 'HARD8TH'});
      }
    },
    show_customer_detail_page(customer_id) {
      this.$router.push({name: "customer_details", 'params':{customer_id: customer_id, is_noah: 0} });
    },

  }
}
</script>

<style scoped>

.full_page {
  margin-left: 20px;
  margin-right: 20px;
}

.mark_different {
  color: blue;


}

</style>
